// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"69cc7949","453":"adef99ea","628":"8e30e1e8"}[chunkId] + ".chunk.js";
};